package game

import com.soywiz.korim.color.Colors
import com.soywiz.korim.color.RGBA

enum class CgaColor(var rgba: RGBA) {
    BLACK(Colors.BLACK),
    BLUE(RGBA(0x00, 0x00, 0xAA)),
    GREEN(RGBA(0x00, 0xAA, 0x00)),
    CYAN(RGBA(0x00, 0xAA, 0xAA)),
    RED(RGBA(0xAA, 0x00, 0x00)),
    MAGENTA(RGBA(0xAA, 0x00, 0xAA)),
    BROWN(RGBA(0xAA, 0x55, 0)),
    LIGHT_GRAY(RGBA(0xAA, 0xAA, 0xAA)),
    DARK_GRAY(RGBA(0x55, 0x55, 0x55)),
    LIGHT_BLUE(RGBA(0x55, 0x55, 0xFF)),
    LIGHT_GREEN(RGBA(0x55, 0xFF, 0x55)),
    LIGHT_CYAN(Colors.CYAN),
    LIGHT_RED(RGBA(0xFF, 0x55, 0x55)),
    LIGHT_MAGENTA(RGBA(0xFF, 0x55, 0xFF)),
    YELLOW(Colors.YELLOW),
    WHITE(Colors.WHITE);

    companion object {
        operator fun get(index: Int): CgaColor {
            return values()[index]
        }

        operator fun get(rgb: RGBA): Int {
            return values().indexOfFirst { it.rgba == rgb }
        }

        fun toCgaColor(rgba: RGBA): CgaColor {
            return values().first { it.rgba == rgba }
        }

        fun lighter(rgba: RGBA, amount: Int): CgaColor = lighter(toCgaColor(rgba), amount)

        fun lighter(color: CgaColor, amount: Int): CgaColor =
            when (amount) {
                0 -> color
                1 -> lighter1(color)
                2 -> lighter2(color)
                3 -> lighter3(color)
                else -> WHITE
            }

        fun lighter1(color: CgaColor): CgaColor {
            return when (color) {
                BLACK -> DARK_GRAY
                BLUE -> LIGHT_BLUE
                GREEN -> LIGHT_GREEN
                CYAN -> LIGHT_CYAN
                RED -> LIGHT_RED
                MAGENTA -> LIGHT_MAGENTA
                BROWN -> YELLOW
                LIGHT_GRAY -> WHITE
                DARK_GRAY -> LIGHT_GRAY
                LIGHT_BLUE -> LIGHT_CYAN
                LIGHT_GREEN -> WHITE
                LIGHT_CYAN -> WHITE
                LIGHT_RED -> WHITE
                LIGHT_MAGENTA -> WHITE
                YELLOW -> WHITE
                WHITE -> WHITE
            }
        }

        fun darker(rgba: RGBA, amount: Int): CgaColor = darker(toCgaColor(rgba), amount)

        fun darker(color: CgaColor, amount: Int): CgaColor =
            when (amount) {
                0 -> color
                1 -> darker1(color)
                2 -> darker2(color)
                3 -> darker3(color)
                else -> BLACK
            }

        fun lighter2(color: CgaColor) = lighter1(lighter1(color))
        fun lighter3(color: CgaColor) = lighter2(lighter1(color))

        fun darker1(color: CgaColor): CgaColor {
            return when (color) {
                BLACK -> BLACK
                BLUE -> DARK_GRAY
                GREEN -> DARK_GRAY
                CYAN -> DARK_GRAY
                RED -> DARK_GRAY
                MAGENTA -> DARK_GRAY
                BROWN -> DARK_GRAY
                LIGHT_GRAY -> DARK_GRAY
                DARK_GRAY -> BLACK
                LIGHT_BLUE -> BLUE
                LIGHT_GREEN -> GREEN
                LIGHT_CYAN -> CYAN
                LIGHT_RED -> RED
                LIGHT_MAGENTA -> MAGENTA
                YELLOW -> BROWN
                WHITE -> LIGHT_GRAY
            }
        }

        fun darker2(color: CgaColor) = darker1(darker1(color))
        fun darker3(color: CgaColor) = darker2(darker1(color))

        fun redden(color: RGBA) = redden(toCgaColor(color))

        fun redden(color: CgaColor): CgaColor {
            return when (color) {
                BLACK, RED -> BLACK
                BLUE, GREEN, CYAN, MAGENTA, BROWN, DARK_GRAY -> LIGHT_RED
                LIGHT_GRAY,
                LIGHT_BLUE,
                LIGHT_GREEN,
                LIGHT_CYAN,
                LIGHT_RED,
                LIGHT_MAGENTA,
                YELLOW,
                WHITE
                -> RED
            }
        }
    }
}
